import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "mapFilled"
const MapFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M14.25 13.616C15.924 13.788 17.438 14.15 18.653 14.656 19.52 15.018 20.273 15.468 20.819 16.006 21.368 16.547 21.75 17.221 21.75 18S21.368 19.453 20.82 19.994C20.272 20.532 19.52 20.982 18.652 21.344 16.913 22.07 14.56 22.5 12 22.5S7.088 22.07 5.347 21.344C4.48 20.982 3.727 20.532 3.181 19.994 2.632 19.453 2.25 18.779 2.25 18S2.632 16.547 3.18 16.006C3.728 15.468 4.48 15.018 5.348 14.656 6.562 14.149 8.077 13.788 9.75 13.616V15.123C8.262 15.289 6.95 15.613 5.925 16.041 5.165 16.358 4.598 16.716 4.233 17.075 3.872 17.432 3.75 17.744 3.75 18S3.872 18.569 4.233 18.925C4.598 19.285 5.164 19.642 5.925 19.959 7.44 20.591 9.589 21 12 21S16.558 20.591 18.075 19.96C18.835 19.641 19.402 19.283 19.767 18.924 20.128 18.568 20.25 18.256 20.25 18S20.128 17.431 19.767 17.075C19.402 16.715 18.836 16.358 18.075 16.041 17.051 15.614 15.738 15.289 14.25 15.123z" />
          <path d="M12 1.5C14.071 1.5 15.75 3.179 15.75 5.25 15.75 7.064 14.462 8.577 12.75 8.925V18C12.75 18.414 12.414 18.75 12 18.75S11.25 18.414 11.25 18V8.925C9.538 8.577 8.25 7.065 8.25 5.25 8.25 3.179 9.929 1.5 12 1.5" />
        </svg>
      }
    </span>
  )
}
export default MapFilledIcon
